export const openNewTab = (url: string) => {
  if (!url) return;
  if (url) window.open(url, "_blank", "noopener,noreferrer");
};
